module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group--two-columns"
  }, _vm._l((_vm.settings), function(item, index) {
    return (_vm.settings.length >= 1) ? _c('div', {
      staticClass: "form-row"
    }, [(item.type === 1) ? _c('el-form-item', {
      staticClass: "item-checkbox"
    }, [_c('el-checkbox', {
      attrs: {
        "checked": _vm.settings[index].value,
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.settings[index].value),
        callback: function($$v) {
          _vm.$set(_vm.settings[index], "value", $$v)
        },
        expression: "settings[index].value"
      }
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n        ")]), _vm._v(" "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type === 2) ? _c('el-form-item', {
      staticClass: "custom-label"
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (!_vm.hideTooltip(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.settings[index].value),
        callback: function($$v) {
          _vm.$set(_vm.settings[index], "value", $$v)
        },
        expression: "settings[index].value"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type === 3) ? _c('el-form-item', {
      staticClass: "custom-label"
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-input', {
      staticClass: "settings-input",
      attrs: {
        "type": item.key === _vm.charitiesField ? 'textarea' : 'text',
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.settings[index].value),
        callback: function($$v) {
          _vm.$set(_vm.settings[index], "value", $$v)
        },
        expression: "settings[index].value"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type === 4) ? _c('el-form-item', {
      staticClass: "custom-label"
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (!_vm.hideTooltip(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-select', {
      attrs: {
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.settings[index].value),
        callback: function($$v) {
          _vm.$set(_vm.settings[index], "value", $$v)
        },
        expression: "settings[index].value"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$t('generic.forms.select')
      }
    }), _vm._v(" "), _vm._l((JSON.parse(_vm.settings[index].values)), function(option, key) {
      return _c('el-option', {
        attrs: {
          "label": _vm.$t('management.unit.softwaresettings.' + key.replace(/[ :/]/g, '')),
          "value": key,
          "selected": "selected"
        }
      })
    })], 2)], 1) : _vm._e(), _vm._v(" "), (item.type === 5) ? _c('el-form-item', {
      staticClass: "custom-label"
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-select', {
      attrs: {
        "multiple": "",
        "placeholder": _vm.$t('generic.forms.select'),
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateMultiSelection()
        }
      },
      model: {
        value: (_vm.selectedValues),
        callback: function($$v) {
          _vm.selectedValues = $$v
        },
        expression: "selectedValues"
      }
    }, _vm._l((JSON.parse(_vm.settings[index].values)), function(option, key) {
      return _c('el-option', {
        attrs: {
          "label": option,
          "value": key,
          "selected": "selected"
        }
      })
    }), 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 6) ? _c('div', {
      staticClass: "not-showing"
    }) : _vm._e(), _vm._v(" "), (item.type === 7) ? _c('div', {
      staticClass: "not-showing"
    }) : _vm._e(), _vm._v(" "), (item.type === 8) ? _c('div', {
      staticClass: "not-showing"
    }) : _vm._e(), _vm._v(" "), (item.type === 9) ? _c('el-form-item', {
      staticClass: "custom-label"
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "disabled": !_vm.overridden || _vm.readOnly,
        "checked": _vm.timePickerEnabled
      },
      on: {
        "change": function($event) {
          _vm.updateTimeStampSelection()
        }
      },
      model: {
        value: (_vm.timePickerEnabled),
        callback: function($$v) {
          _vm.timePickerEnabled = $$v
        },
        expression: "timePickerEnabled"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('management.unit.softwaresettings.timeSelector.enabled')) + "\n        ")]), _vm._v(" "), _c('el-time-select', {
      attrs: {
        "disabled": !_vm.overridden || _vm.readOnly || !_vm.timePickerEnabled,
        "picker-options": {
          start: '00:00',
          step: '00:30',
          end: '23:30'
        }
      },
      on: {
        "change": function($event) {
          _vm.updateTimeStampSelection()
        }
      },
      model: {
        value: (_vm.timePickerTimeStamp),
        callback: function($$v) {
          _vm.timePickerTimeStamp = $$v
        },
        expression: "timePickerTimeStamp"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type === 10) ? _c('el-form-item', {
      staticClass: "custom-label"
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "disabled": !_vm.overridden || _vm.readOnly,
        "checked": _vm.useDefaultValues[index]
      },
      on: {
        "change": function($event) {
          _vm.updateDefaultValueSelection(index)
        }
      },
      model: {
        value: (_vm.useDefaultValues[index]),
        callback: function($$v) {
          _vm.$set(_vm.useDefaultValues, index, $$v)
        },
        expression: "useDefaultValues[index]"
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t('management.unit.softwaresettings.useDefaultValue')) + "\n      ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.useDefaultValues[index]),
        expression: "!useDefaultValues[index]"
      }],
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "disabled": !_vm.overridden || _vm.readOnly
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": item.key
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.settings[index].value),
        callback: function($$v) {
          _vm.$set(_vm.settings[index], "value", $$v)
        },
        expression: "settings[index].value"
      }
    })], 1), _vm._v(" "), (_vm.overridden && !_vm.readOnly) ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.generateNewDefaultValue(index)
        }
      }
    }, [_vm._v("Generate")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 11) ? _c('div', [_c('el-form-item', {
      staticClass: "custom-label"
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "timer-show",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('vue-timepicker', {
      attrs: {
        "drop-direction": "up",
        "disabled": !_vm.overridden || _vm.readOnly,
        "format": "mm:ss"
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.settings[index].value),
        callback: function($$v) {
          _vm.$set(_vm.settings[index], "value", $$v)
        },
        expression: "settings[index].value"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 12) ? _c('div', [_c('el-form-item', {
      staticClass: "custom-label"
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "timer-show",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('vue-timepicker', {
      attrs: {
        "drop-direction": "up",
        "disabled": !_vm.overridden || _vm.readOnly,
        "format": "HH:mm:ss"
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.settings[index].value),
        callback: function($$v) {
          _vm.$set(_vm.settings[index], "value", $$v)
        },
        expression: "settings[index].value"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 13) ? _c('div', {
      staticClass: "custom-label"
    }, [_c('div', {
      staticClass: "el-form-item__label form__percentage-field"
    }, [_c('span', {
      staticClass: "form__percentage-field-label",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n          "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.unit.toolTip.' + item.key)))])]) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
      staticClass: "side--label",
      attrs: {
        "label": _vm.$t('management.unit.form.' + item.key),
        "prop": "alarmOn"
      }
    }, [_c('span', {
      staticClass: "label--after input-number"
    }, [_vm._v("%")]), _vm._v(" "), _c('el-input-number', {
      attrs: {
        "id": "unit-alarm-on-input",
        "min": 0,
        "max": 100,
        "disabled": !_vm.overridden || _vm.readOnly
      },
      model: {
        value: (_vm.settings[index].value),
        callback: function($$v) {
          _vm.$set(_vm.settings[index], "value", $$v)
        },
        expression: "settings[index].value"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.type === 16) ? _c('el-form-item', {
      staticClass: "custom-label"
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("\n        " + _vm._s(_vm.$t('management.unit.softwaresettings.' + item.key)) + "\n        "), (_vm.hasToolTipTranslationKey(item.key)) ? _c('div', {
      staticClass: "help-tip"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('management.softwaresettings.toolTip.' + item.key)))])]) : _vm._e()]), _vm._v(" "), _c('el-input', {
      staticClass: "settings-input",
      attrs: {
        "type": "password",
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateMaskedKeys(index)
        }
      },
      model: {
        value: (_vm.settings[index].parsedValue),
        callback: function($$v) {
          _vm.$set(_vm.settings[index], "parsedValue", $$v)
        },
        expression: "settings[index].parsedValue"
      }
    })], 1) : _vm._e()], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-800cf66a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/settingspanel/src/settingspanel.vue
// module id = 512
// module chunks = 36